var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "f7-panel",
    {
      staticClass: "showSmallScreenOnly",
      attrs: {
        id: "right-panel-root",
        side: "right",
        effect: "cover",
        layout: "layout-white",
        theme: "white",
        opened: _vm.isOpen,
      },
      on: {
        "panel:opened": function ($event) {
          _vm.isOpen = true
        },
        "panel:closes": function ($event) {
          _vm.isOpen = false
        },
      },
    },
    [
      _c("div", { staticClass: "navbar" }, [
        _c("div", { staticClass: "navbar-inner no-swipeback" }, [
          _c(
            "div",
            { staticClass: "left", staticStyle: { "padding-left": "10px" } },
            [
              _c("i", {
                staticClass: "icon imgClosePanel",
                class: _vm.imgCross,
                on: {
                  click: function ($event) {
                    _vm.isOpen = false
                  },
                },
              }),
              _vm._v(" "),
              _c("p", { staticStyle: { "padding-left": "10px" } }, [
                _vm._v(_vm._s(_vm.pageTitle)),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.feature === "filter-messages"
        ? _c("RightPanelFilterView", { attrs: { serviceId: _vm.serviceId } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }